import { WebApiRequest, HTTP_GET } from "tools/webservice";
import { AppraiserCaseResult } from "interfaces/Mueller.Business.Models";
import { SearchResultDto } from "interfaces/BusinessModelsExtensions";
import { Ref } from "react";


export const getAssignedCases = (appraiserId: number, successCallback: (data: SearchResultDto<AppraiserCaseResult>) => void, mountedRef: Ref<Boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint:`/appraiser-case/${appraiserId}/assigned`,
  successCallback,
  mountedRef,
});